import {
  useQuery,
  UseQueryResult,
  UseQueryOptions,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import { buildQueryString } from "@mimber-client/utils"
import { HouseholdDto, ResponseDto, QueryParamsDto } from "@mimber/schema"
import { householdsKeys } from "../households.utils"

/**
 * Organization-specific hook for fetching households (admin reporting)
 * Can only be used in mimber-organization app
 * The organization context is automatically handled by ServerContext
 */
export const useHouseholds = (
  params?: QueryParamsDto,
  options?: UseQueryOptions<ResponseDto<HouseholdDto[]>, Error>
): UseQueryResult<ResponseDto<HouseholdDto[]>, Error> => {
  guardAppUsage("mimber-organization", "useHouseholds")

  const { server } = useServerContext()

  return useQuery({
    queryKey: householdsKeys.findAll(params),
    queryFn: async () => {
      const response = await server.get<ResponseDto<HouseholdDto[]>>(
        buildQueryString("households", params)
      )
      return response.data
    },
    staleTime: 5 * 60 * 1000,
    ...options,
  })
}
